const formatGraphErrors = (graphQLErrors, networkError) => {
  const errorObj = graphQLErrors[0]
    ? { ...graphQLErrors[0] }
    : {
        ...networkError,
        ...(networkError && networkError.result && networkError.result.errors
          ? networkError.result.errors[0]
          : {})
      };

  if (
    errorObj &&
    errorObj.extensions &&
    errorObj.extensions.exception &&
    errorObj.extensions.exception.locations
  ) {
    delete errorObj.extensions.exception.locations;
  }
  if (errorObj && errorObj.result && errorObj.result.errors) delete errorObj.result.errors;
  if (errorObj) delete errorObj.locations;

  return errorObj;
};

export default {
  formatGraphErrors
};
